import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Bank, BankOption } from '@core/model/domain/bank';
import { TranslateModule } from '@ngx-translate/core';
import { StoreService } from '@shared/services/store.service';
import { TrackerService } from '@shared/services/tracker.service';
import { RegionalBankComponent } from './components/regional-bank.component';
import { SearchBarComponent } from '../../../../shared/components/search-bar/search-bar.component';

@Component({
  selector: 'app-select-regional-bank',
  templateUrl: './select-regional-bank.component.html',
  standalone: true,
  imports: [FormsModule, TranslateModule, RegionalBankComponent, SearchBarComponent],
})
export class SelectRegionalBankComponent implements OnInit {
  searchTerm: string = '';
  bank: Bank;
  regionalBankOption!: BankOption[];

  constructor(
    private readonly tracker: TrackerService,
    private readonly storeService: StoreService
  ) {
    this.bank = this.storeService.getVariableOrThrow('SELECTED_BANK');
  }

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'SELECT_REGIONAL_BANK' });
    this.regionalBankOption = this.bank.form[0]!.options!;
  }

  searchTermChanged(value: string) {
    this.searchTerm = value;
  }

  get filteredRegionalBankOption(): BankOption[] {
    return this.regionalBankOption.filter((option) =>
      option.name.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase())
    );
  }
}
